import {defineSlotRecipe} from '@chakra-ui/react3'

/**
 * Recipe for the `Certificates` partial.
 */
export default defineSlotRecipe({
    slots: [
        'container',
        'button',
        'buttonImage',
        'backdrop',
        'content',
        'closeTrigger',
        'body',
        'title',
        'contentWrapper',
        'imageContainer',
        'image',
        'name',
        'description'
    ],
    base: {
        container: {
            gap: 'spacing-16',
            flexWrap: 'nowrap',
            overflowX: 'auto',
            overflowY: 'hidden'
        },
        button: {
            height: '4.5rem',
            flexShrink: 0,
            cursor: 'pointer',
            background: 'none',
            border: 'none',
            padding: 0
        },
        buttonImage: {
            width: 'auto',
            height: '100%'
        },
        backdrop: {
            backgroundColor: 'rgba(0, 0, 0, 0.6)'
        },
        content: {
            borderRadius: 'none',
            boxShadow: 'none',
            backgroundColor: 'background.section.default',
            marginY: '5rem',
            width: {base: '100%', s: '41.375rem'},
            maxWidth: {base: '100%', s: '41.375rem'}
        },
        closeTrigger: {
            position: 'absolute',
            top: {base: '1rem', s: '1.5rem'},
            insetEnd: {base: '1rem', s: '1.5rem'},
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxSize: '2.625rem',
            fontSize: '1rem',
            cursor: 'pointer',
            color: 'icons.primary'
        },
        body: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-start',
            height: '100%',
            paddingInline: {base: '1rem', s: '1.5rem'},
            paddingTop: {base: '1rem', xs: '1.5rem'},
            paddingBottom: {base: '2.5rem', xs: '3rem'}
        },
        title: {
            textStyle: 'heading.large'
        },
        contentWrapper: {
            display: 'flex',
            flexDirection: 'column',
            maxWidth: {base: '17.625rem', s: '100%'},
            marginRight: 'auto'
        },
        imageContainer: {
            padding: '0.825rem 1.33125rem 0.93125rem 0',
            marginBottom: '0.5rem'
        },
        image: {
            maxWidth: '19.375rem',
            maxHeight: '12.5rem'
        },
        name: {
            textStyle: 'body.large',
            marginBottom: '0.5rem'
        },
        description: {
            textStyle: 'body.medium'
        }
    }
})
